export const COMPANIES = 'companies';
export const COMPANIES_LIST_SUCCESSFUL = 'companies_list_successfull';
export const API_ERRORS = 'api_failed';